export const actionConst = {
    OPEN_NEW_DOCUMENT_MODAL: 'OPEN_NEW_WDOCUMENT_MODAL',
    UPDATE_NEW_DOCUMENT_MODAL: 'UPDATE_NEW_WDOCUMENT_MODAL',
    CLOSE_NEW_DOCUMENT_MODAL: 'CLOSE_NEW_WDOCUMENT_MODAL',
    FETCH_DOCTYPE_REF: 'FETCH_WDOCTYPE_REF', 
    POST_DOCUMENT: 'POST_WDOCUMENT',
    DELETE_DOCUMENT: 'DELETE_WDOCUMENT',
    RESET_POSTED_REQUEST: 'RESET_POSTED_REQUEST'
};
